// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=UploadUrlResponse|schemaHash=ab7c253bd69020fe10ebfd1389e6982fcae997f0

import { setDefinedValue } from '@myre/common-primitives';

export function parseUploadUrlResponseFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'fileId', _data.fileId);
  setDefinedValue(result, 'url', _data.url);

  return result;
}

export function parseUploadUrlResponseToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'fileId', _data.fileId);
  setDefinedValue(result, 'url', _data.url);

  return result;
}
